export default "__VITE_ASSET__018d8b14__"